import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class NewUnit extends BaseApi {
  constructor() {
    super({ suffix: "" });
  }

  listAllTemplate(params) {
    return this.httpService.get("Definition/all-template", { headers, params });
  }

  postNewUnit(data) {
    return this.httpService.post("Project/insert-unit", data, { headers });
  }

  getInfoUnitWizard(params) {
    return this.httpService.get("project/info-update-unit-wizard", {
      headers,
      params,
    });
  }
}

const NewUnitService = new NewUnit();
export default NewUnitService;
